import { BopsLogo, dashboard_icon, integration_icon } from '@Assets';
import { ReactComponent as IconAi } from '@Assets/icon_ai.svg';

const ORBIT_GLYPHS = [
  { src: dashboard_icon, label: 'Monitor' },
  { Icon: IconAi, label: 'Agent' },
  { src: integration_icon, label: 'Integrations' },
];

const MotifOrbit = () => (
  <div className="relative w-[260px] h-[260px] flex items-center justify-center">
    {/* Orbit rings */}
    <div className="absolute inset-0 rounded-full border border-dashed border-brand-500/[0.28]" />
    <div className="absolute inset-[30px] rounded-full border border-brand-500/[0.14]" />

    {/* Orbiting group */}
    <div className="absolute inset-0 animate-es-orbit">
      {ORBIT_GLYPHS.map((g, i) => {
        const angle = (i * 360) / ORBIT_GLYPHS.length;
        return (
          <div
            key={g.label}
            className="absolute top-1/2 left-1/2"
            style={{ transform: `rotate(${angle}deg) translateY(-130px)`, transformOrigin: '0 0' }}>
            <div
              className="w-11 h-11 rounded-xl bg-white border border-gray-200 shadow-[0_4px_12px_rgba(16,24,40,0.08)] flex items-center justify-center -ml-[22px] -mt-[22px]"
              style={{ transform: `rotate(${-angle}deg)` }}>
              {g.Icon ? (
                <g.Icon className="w-[22px] h-[22px] opacity-75" />
              ) : (
                <img src={g.src} className="w-[22px] h-[22px] opacity-75" alt="" />
              )}
            </div>
          </div>
        );
      })}
    </div>

    {/* Center mark */}
    <div className="relative z-[2] w-24 h-24 rounded-full bg-gradient-to-br from-white to-[#f3f1ff] border border-gray-200 shadow-[0_0_28px_rgba(124,108,246,0.35),0_10px_30px_rgba(16,24,40,0.08)] flex items-center justify-center">
      <BopsLogo className="h-[46px]" />
    </div>
  </div>
);

export default MotifOrbit;
